<template>
  <div class="serviceList">
    <div class="serviceMain">
      <div class="infosearch">
        <span class="labelTit">会员手机号</span>
        <el-input v-model="memberPhone" placeholder="输入会员手机号" style="width: 220px;margin-right: 10px" @keyup.enter.native="search(1)"></el-input>
        <span class="labelTit">服务日期</span>
        <el-date-picker
          v-model="orderTime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
          style="width: 260px;margin-right: 10px"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <el-button
          class="searchBtn"
          @click="search(1)"
          v-loading.fullscreen.lock="fullscreenLoading"
        ></el-button>
      </div>
      <el-table
        v-if="tableData.length > 0"
        :data="tableData"
        min-height="602"
        ref="multipleTable"
        @cell-click="linkTo"
        :cell-class-name="tableRowClassName"
        class="myMemTable"
        style="width: 100%"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="id" label="服务单编号">
          <template slot-scope="scope">
            <span class="blue cursorHand">{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isAppoint" label="是否预约" width="80">
          <template slot-scope="scope">{{scope.row.isAppoint == 1?'是':'否' | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="memberName" label="会员"></el-table-column>
        <el-table-column align="center" prop="memberPhone" label="手机号">
          <template slot-scope="scope">{{scope.row.memberPhone | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="serviceList" label="项目">
          <template slot-scope="scope">
              <el-row class="tableGoods" v-if="scope.row.serviceList.length > 0">
                  <el-popover trigger="hover" placement="top">
                      <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                      <el-col slot="reference" class="myTitle">
                          <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                      </el-col>
                  </el-popover>
              </el-row>
              <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="technicianName" label="员工"></el-table-column>
        <el-table-column align="center" prop="startTime" label="服务日期" width="100">
          <template slot-scope="scope">
            {{scope.row.startTime | formatDateNoHouer}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="scheduleStartTime" label="预约时间" width="170">
          <template slot-scope="scope">
            {{scope.row.scheduleStartTime | filterRow}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间" width="145">
          <template slot-scope="scope">
            {{scope.row.createTime | formatDateLine}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <p class="redFont" v-if="scope.row.status == 1 && scope.row.notTakingOverTimeMins >0">未接单<br/><span v-if="scope.row.notTakingOverTimeMins && scope.row.notTakingOverTimeMins>0">(超时{{scope.row.notTakingOverTimeMins+'min'}})</span></p>
            <p class="greenFont" v-else-if="scope.row.status == 1">待接单</p>
            <p class="blueFont" v-else-if="scope.row.status == 2">未开始<br/><span v-if="scope.row.unstartOverTimeMins && scope.row.unstartOverTimeMins>0">(超时{{scope.row.unstartOverTimeMins+'min'}})</span></p>
            <p v-else-if="scope.row.status == 3">服务中</p>
            <p v-else-if="scope.row.status == 4">已结束</p>
            <p v-else-if="scope.row.status == 5">已取消</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" class-name="operation">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 1 && scope.row.notTakingOverTimeMins>0 ">
              <!-- 超时未接单 -->
              <el-button size="mini" type="primary" @click="toDispatch(scope.row)">人工派单</el-button>
            </template>
            <template v-else-if="scope.row.status == 1">
              <!-- 待接单 -->
              <el-button size="mini" @click="toView(scope.row)">查看</el-button>
            </template>
            <template v-else-if="scope.row.status == 2">
              <!-- 待服务 -->
              <el-button size="mini" class="redBtn" @click="toOpenOrder(scope.row)">开始服务</el-button>
              <el-button size="mini" class="darkBtn" @click="toChangeOrder(scope.row)">转单</el-button>
              <el-button size="mini" @click="toCancel(scope.row)">取消</el-button>
            </template>
            <template v-else-if="scope.row.status == 3">
              <!-- 服务中 -->
              <el-button size="mini" @click="toOver(scope.row)">结束</el-button>
            </template>
            <template v-else-if="scope.row.status == 4">
              <!-- 已结束 -->
              <el-button size="mini" @click="toView(scope.row)">查看</el-button>
            </template>
            <template v-else-if="scope.row.status == 5">
              <!-- 已取消 -->
              <el-button size="mini" @click="toView(scope.row)">查看</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到服务单信息！再核对一下试试</div>
      </template>

      <el-pagination
        v-if="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px;text-align:right"
      ></el-pagination>
    </div>

    <el-dialog title="服务单详情" :visible.sync="dialogDetailVisible" :center="true" width="580px">
      <!-- 服务单详情 -->
      <serviceDetail @closeDialog="closeDialog" :curChooseRow="curChooseRow"/>
    </el-dialog>
    <el-dialog :title="orderFlag ? '转单':'人工派单'" :visible.sync="dialogChangeVisible" :center="true" width="580px">
      <!-- 转单，人工派单 -->
      <orderChange :orderFlag="orderFlag" @closeDialog="closeDialog" :curChooseRow='curChooseRow'/>
    </el-dialog>
    <el-dialog :title="dialogType === 1 ? '电话确认':(dialogType === 2 ? '人工派单':(dialogType === 3 ? '确认开始服务':(dialogType === 4 ? (nextPart?'确认结束服务':'预约下次服务'):(dialogType === 5?'取消服务单':''))))" class="dialogVisible" :visible.sync="dialogTableVisible" :center="true" width="580px">
        <confirmTel :dialogType="dialogType" :dialogTableVisible="dialogTableVisible" :nextPart="nextPart" @closeDialog="closeDialog" @cancelDialog="cancelDialog" @refresh="refresh" :curRowchoose="curChooseRow"/>
    </el-dialog>
    <el-dialog class="dialogVisible" :visible.sync="dialogSetpwd" :center="true" width="800px">
        <setPwd :setpayPwd="setpayPwd" :dialogSetpwd="dialogSetpwd" @closeset="closeset"/>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import {formatDate} from '@/components/common/js/date.js';  
import { serviceOrderList } from "@/api";
import serviceDetail from "./serviceDetail";
import orderChange from "./orderChange";
import confirmTel from '../operatingFloor/confirmTel';
import setPwd from '@/components/basicDataCenter/setPsd'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    serviceDetail,orderChange,confirmTel,setPwd
  },
  data() {
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      memberPhone: "",
      orderTime: [],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      mySearchflag: false,
      fullscreenLoading: false,
      dialogDetailVisible: false, //服务单详情弹窗
      dialogChangeVisible:false,//转单
      orderFlag:true,//true转单false派单
      curChooseRow:'',
      dialogTableVisible: false,
      dialogType:'',// 几个弹窗的识别
      nextPart:true,//结束服务单默认有下一步选择下次预约时间
      dialogSetpwd:false,
      setpayPwd:''
    };
  },
  created() {
    this.currentPage =  this.$store.state.alivePage;
    this.search();
    this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.currentPage = 1;
      }
      let res = await serviceOrderList({
        memberPhone: this.memberPhone,
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        todayFlag:'0',
        overTimeFlag:'2',
        startTime:this.orderTime?this.orderTime[0]:'',
        endTime:this.orderTime?this.orderTime[1]:''
      });
      this.fullscreenLoading = false;
      if (res.data.items.length == 0) {
        this.mySearchflag = true;
      }
      this.total = res.data.totalNum;
      this.tableData = res.data.items;
      if(this.tableData.length > 0){
        for(let list of this.tableData){
          if(list.scheduleStartTime){
            list.scheduleStartTime = formatDate(list.scheduleStartTime,'yyyy-MM-dd ')+formatDate(list.scheduleStartTime,'HH:mm')+'-'+formatDate(list.scheduleEndTime,'HH:mm')
          }
        }
      }
    },
    linkTo(row, column) {
      // 跳转详情
      if(column.property == 'id'){
          this.$router.push("/financeManageCenter/serviceDetail" + row.id);
          this.$store.commit('setAlivePage',this.currentPage)
      }
    },
    toDispatch(curRowchoose) {
      //   人工派单
      this.orderFlag = false;
      this.dialogChangeVisible = true;
      this.curChooseRow = curRowchoose;
    },
    toOpenOrder(curRowchoose) {
      //   开始服务
      this.dialogTableVisible = true;
      this.dialogType = 3;
      this.curChooseRow = curRowchoose;
    },
    toChangeOrder(curRowchoose) {
      //   转单
      this.orderFlag = true;
      this.dialogChangeVisible = true;
      this.curChooseRow = curRowchoose;
    },
    toView(curRowchoose) {
      //   查看
      this.dialogDetailVisible = true;
      this.curChooseRow = curRowchoose;
    },
    toOver(curRowchoose) {
      //   结束
      this.dialogTableVisible = true;
      this.dialogType = 4;
      this.curChooseRow = curRowchoose;
      this.nextPart = true;
    },
    toCancel(curRowchoose){
      // 取消
      this.dialogTableVisible = true;
      this.dialogType = 5;
      this.curChooseRow = curRowchoose;
    },
    closeDialog(val) {
      this.dialogDetailVisible = val;
      this.dialogChangeVisible = val;
      this.dialogTableVisible = val;
      this.search();
      if(val === 'nextPart'){
        this.nextPart = true;
        this.dialogDetailVisible = false;
        this.dialogChangeVisible = false;
        this.dialogTableVisible = false;
      }
    },
    cancelDialog(val){
      this.dialogTableVisible = false;
      this.dialogSetpwd = true;
      this.setpayPwd = val;
    },
    closeset(val){
      this.dialogSetpwd = val;
      this.dialogTableVisible = true;
      this.dialogType = 3;
    },
    refresh(val){
      this.search();
      if(val.isAppointStatus == 1){
        this.nextPart = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.serviceMain {
  padding: 25px 0;
  .labelTit {
    color: #666;
    margin-right: 5px;
  }
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .redFont{
      color: #F83B56;
      span{
        color: #666
      }
    }
    .greenFont{
      color: #2ECFA7
    }
    .blueFont{
      color: #21A3F5;
      span{
        color: #666
      }
    }
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.serviceList {
  .el-dialog__title {
    font-weight: bold;
  }
}
.serviceMain {
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/businessManagementCenter/serviceList.vue